import React from 'react';
import PropTypes from 'prop-types';
import SelectedAccountComponent from './SelectedAccountComponent';
import MoveMoneyBL from './MoveMoneyBL';

class PaymentAccountCardInfo extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.data);
  }

  // TODO : Check later
  checkKeyPress(e) {
    if (e.which === 40 || e.keyCode === 40) {
      if (document.activeElement.nextSibling) {
        document.activeElement.nextSibling.focus();
      }
    } else if (e.which === 38 || e.keyCode === 38) {
      if (document.activeElement.previousSibling) {
        document.activeElement.previousSibling.focus();
      }
    } else if (e.which === 13 || e.keyCode === 13) {
      this.onClick();
      e.preventDefault();
    }
  }

  render() {
    let componentName;
    if (MoveMoneyBL.getAccountNickname(this.props.data)) {
      componentName = 'componentA';
    } else {
      componentName = 'componentB';
    }
    // Logic to show correct format of selected account
    return (
      <li
        role="option"
        className="account-card"
        tabIndex="0"
        onClick={this.onClick}
        ref={`cardItem${this.props.index}`}
        onKeyDown={this.checkKeyPress}
      >
        <SelectedAccountComponent
          componentName={componentName}
          selectedAccount={this.props.data}
        />
      </li>
    );
  }
}

PaymentAccountCardInfo.propTypes = {
  data: PropTypes.object, // Account Details
  name: PropTypes.string,
  index: PropTypes.number,
  onClick: PropTypes.func,
};

PaymentAccountCardInfo.defaultProps = {
  data: {},
  name: '',
  index: 0,
};

export default PaymentAccountCardInfo;
